/* eslint-disable @typescript-eslint/no-unused-vars */
import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '../../_theme/layout/MasterLayout'
import { ProjectPage } from '../pages/project/ProjectPage'
import { ManageProject } from '../pages/project/ManageProject'
import { ManageProjectStage } from '../pages/project/ManageProjectStage'
import { DashBoardNew } from '../modules/Dashboard'
import { SinglePageReport } from '../pages/project/SinglePageReport'
import { ElevatorPitchPage } from '../pages/project/ElevatorPitchPage'
import NotificationManagement from '../modules/notification/notfication'
import { PanopticEvaluationSummaryPreview } from '../pages/project/PanopticEvaluationSummaryPreview'
import { PanopticEvaluationScoreCard } from '../pages/PanopticEvaluationScoreCard'
import Calendar from '../modules/Dashboard/calendar/calender'
import { PET } from '../modules/project/pet'
import RequirePermission from '../modules/apps/components/UI/RequirePermission'

const PrivateRoutes = () => {
  return (
    <Routes>
      <Route element={<MasterLayout />}>

        {/* Dashboard */}
        <Route path="dashboard/:type?" element={<DashBoardNew />} />

        {/* Projects */}
        <Route path="projects" element={<RequirePermission right="stage_gate_dashboard"><ProjectPage /></RequirePermission>} />
        <Route path="manage-project/:project_id" element={<RequirePermission right="workflow"><ManageProject /></RequirePermission>} />
        <Route path="manage-project/:project_id/:dk_stage" element={<ManageProjectStage />} />

        {/* Reports */}
        <Route path="manage-project/single-page-report/:project_id" element={<RequirePermission right="stage_gate_4"><SinglePageReport /></RequirePermission>} />
        <Route path="manage-project/elevator-pitch/:project_id" element={<RequirePermission right="stage_gate_4"><ElevatorPitchPage /></RequirePermission>} />

        <Route path='manage-notifications' element={<NotificationManagement />} />
        <Route path='panoptic-evaluation-summary/:project_id' element={<RequirePermission right="panoptic_evaluation_summary_report"><PanopticEvaluationSummaryPreview /></RequirePermission>} />        {/* Page Not Found */}
        <Route path='panoptic-evaluation-score-card' element={<RequirePermission right="panoptic_evaluation_dashboard"><PanopticEvaluationScoreCard /></RequirePermission>} />
        <Route path="manage-events" element={<Calendar />} />

        <Route path="pet/:project_id/:tab?" element={<RequirePermission right="project_evaluation_tool"><PET /></RequirePermission>} />


        {/* 404 */}
        <Route path="*" element={<Navigate to="/error/404" />} />

      </Route>
    </Routes>
  )
}

export { PrivateRoutes }
